import { render, staticRenderFns } from "./PairDialog.vue?vue&type=template&id=059077e4&scoped=true"
import script from "./PairDialog.vue?vue&type=script&lang=js"
export * from "./PairDialog.vue?vue&type=script&lang=js"
import style0 from "./PairDialog.vue?vue&type=style&index=0&id=059077e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059077e4",
  null
  
)

export default component.exports